(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/statistics/navbig/assets/javascripts/commands/nav-big-league-command.js') >= 0) return;  svs.modules.push('/components/statistics/navbig/assets/javascripts/commands/nav-big-league-command.js'); 
var svs = svs || {};

(function(svs) {
  'use strict';

  svs.statistics = svs.statistics || {};
  svs.statistics.big = svs.statistics.big || {};
  svs.statistics.big.commands = svs.statistics.big.commands || {};

  svs.statistics.big.commands.NavBigLeagueCommand = function() {
    var assetsLoaded = false;

    var doCreateLeague = function(options) {
      if (
        _.isObject(options.model) &&
        options.model instanceof svs.sport.sport_search.models.SearchTeamList
      ) {
        if (_.isObject(options.model.get('league'))) {
          options.model.set(
            { leagueId: options.model.get('league').id },
            { silent: true }
          );
        }
        options.model = $.extend(
          new svs.statistics.big.models.LeagueBigStatisticsModel(),
          options.model
        );
      }

      if (
        !_.isObject(options.model) ||
        !(
          options.model instanceof
          svs.statistics.big.models.LeagueBigStatisticsModel
        )
      ) {
        options.model = new svs.statistics.big.models.LeagueBigStatisticsModel({
          leagueId: options.leagueId,
          tab: options.tab
        });
        options.preDraw = false;

        if (
          options.callType === svs.statistics.big.commands.DEEP_NAVIGATION &&
          options.preDrawType !== svs.statistics.big.commands.PRE_DRAW_LEAGUE
        ) {
          options.skippAnim = options.skippAnim || false;
        } else {
          options.skippAnim = options.skippAnim || true;
        }
      }
      return {
        view: new svs.statistics.big.views.LeagueBigStatisticsView(options),
        model: options.model
      };
    };

    var loadLeague = function(options, cb, cbFunc) {
      options = _.extend(
        {
          leagueId: '',
          bigNavRef: this
        },
        options
      );

      options.cb = cb;
      options.cbFunc = cbFunc;

      async.parallel(
        [
          function loadAssets(callback) {
            if (assetsLoaded) {
              callback();
            } else {
              svs.core.module.load(
                '/sportservice/liga/{id}',
                null,
                callback,
                options.leagueId
              );
            }
          }
        ],
        onAssetsLoadedAndLeagueFetched
      );

      function onAssetsLoadedAndLeagueFetched() {
        assetsLoaded = true;
        options.cb[options.cbFunc](options);

        if (options.cbFunc === 'preDrawLeague') {
          options.cb.preDrawLeagueLoaded(options);
        }
      }

      return assetsLoaded;
    };

    return {
      doCreateLeague: doCreateLeague,
      loadLeague: loadLeague
    };
  };

  svs.statistics.big.commands.navBigLeagueCommand = new svs.statistics.big.commands.NavBigLeagueCommand();
})(svs);

 })(window);